import MainLayout from 'src/layouts';
import { Helmet } from 'react-helmet';
import TradeData from 'src/features/TradeData';
import { ID_COMPONENT_TRADE } from 'src/features/TradeData/config';

const TradeDataPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Trade Data</title>
        <style type="text/css">
          {`
          @media print {
            body * {
              visibility: hidden;
            }
            #${ID_COMPONENT_TRADE}, #${ID_COMPONENT_TRADE} * {
              visibility: visible;
            }
            #${ID_COMPONENT_TRADE} {
              position: absolute;
              left: 0;
              top: 0;
            }
          }
          `}
        </style>
      </Helmet>
      <TradeData />
    </MainLayout>
  );
};

export default TradeDataPage;
